<script lang="ts">
	import AvailabilityButton from '$lib/features/profile/components/AvailabilityButton.svelte';
	// import MessagesNavIcon from '$lib/features/messages/components/MessagesNavIcon.svelte';
	import LucideIcon from '$lib/utils/components/LucideIcon.svelte';

	// import { driver_state } from '$lib/features/profile/states/driver_state';
	import { page } from '$app/state';

	const links = [
		{ icon: 'Truck', page: '/' },
		{ icon: 'Coins', page: '/invoices' },
		{ icon: 'UserCog', page: '/profile' }
	];
</script>

<footer
	class="fixed bottom-0 left-0 right-0 z-[100] flex h-12 w-full items-center justify-evenly border-t border-border bg-background px-0.5 text-muted-foreground sm:justify-center sm:gap-8"
	style="padding-bottom: env(safe-area-inset-bottom, 0px); height: calc(3rem + env(safe-area-inset-bottom, 0px));"
>
	<AvailabilityButton />
	<!-- <MessagesNavIcon own_user={{ role: 'driver', value: driver_state.value }} /> -->
	{#each links as link}
		<a
			href={link.page}
			class="flex h-10 w-10 items-center justify-center rounded-lg transition-colors duration-300 ease-linear
			{page.route.id === link.page ? 'bg-primary/10 text-primary' : ''}
			hover:bg-muted hover:text-foreground"
		>
			<LucideIcon name={link.icon} />
		</a>
	{/each}
</footer>
